import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import "../styles/Login.css";

export default function Login() {
  const { login, googleLogin } = useAuth();
  const nav = useNavigate();

  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const onChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(form.email, form.password);
      nav("/");
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      await googleLogin();
      nav("/");
    } catch (err) {
      console.error("Google login error:", err);
      setError("Google sign-in failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="login-page">
      <motion.div
        className="login-card"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <h2 className="login-title">Welcome Back</h2>
        <p className="login-subtitle">Sign in to continue</p>

        <form className="login-form" onSubmit={submit} noValidate>
          <label htmlFor="email">Email Address</label>
          <input
            id="email"
            name="email"
            placeholder="you@example.com"
            value={form.email}
            onChange={onChange}
            type="email"
            autoComplete="email"
            required
          />

          <label htmlFor="password">Password</label>
          <div className="password-wrapper">
            <input
              id="password"
              name="password"
              placeholder="Enter your password"
              type={showPass ? "text" : "password"}
              value={form.password}
              onChange={onChange}
              autoComplete="current-password"
              required
            />
            <span
              className="password-toggle"
              onClick={() => setShowPass(!showPass)}
              role="button"
              aria-label="Toggle password visibility"
            >
              {showPass ? "🙈" : "👁️"}
            </span>
          </div>

          {error && <div className="error-text">{error}</div>}

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <div className="divider"><span>or</span></div>

        <button
          className="google-btn"
          onClick={handleGoogleLogin}
          disabled={loading}
        >
          <img
            src="https://www.svgrepo.com/show/475656/google-color.svg"
            alt="Google"
            className="google-icon"
          />
          Continue with Google
        </button>

        <div className="login-links">
          <p>
            Don’t have an account?{" "}
            <Link to="/register" className="link">Register here</Link>
          </p>
        </div>
      </motion.div>
    </section>
  );
}
